export default "__VITE_ASSET__CKq4WbjJ__"